module.exports = __webpack_public_path__ + "c656b7571fc3abdfc498573aeac6f701.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/fluorescenceScale/very-strong@2x.png
// module id = 855
// module chunks = 0